<template>
    <v-dialog v-model="dialogOpen"
              persistent
              max-width="1000px">
        <v-card>
            <toolbar-page :title="filtersOnly ? 'Select filter' : 'Select segment'" disable-icon>
                <template slot="buttons">

                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="dialogOpen=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </template>

            </toolbar-page>

            <v-alert v-show="filtersOnly" class="mt-2 body-2" type="info">
                Don't see what you are looking for? Remember to tag segment as filter to have it available here.
            </v-alert>

            <segments-index
                    select-only
                    :filters-only="filtersOnly"
                    @select="definitionSelected"
                    @close="definitionClosed"
            ></segments-index>

        </v-card>
    </v-dialog>
</template>

<script>

    import SegmentsIndex from '../../modules/Segments/components/index';
    import ToolbarPage from './ToolbarPage';

    export default {

        components: {
            SegmentsIndex,
            ToolbarPage
        },

        props: {
            value: {
                type: Boolean,
                required: true,
                default: false,
            },
            filtersOnly: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {}
        },

        computed: {
            dialogOpen: {
                get() {
                    return this.value;
                },
                set() {
                    this.closeDialog();
                }
            }
        },

        methods: {

            closeDialog() {
                this.$emit('close', false);
            },

            definitionSelected(definition) {
                this.$emit('select', definition);
            },

            definitionClosed() {
                this.$emit('close');
            }
        }
    }
</script>
